import { fetchAppConfig } from 'state/Config/actions';
import { AppDispatch } from 'state/reducer';
import { setWidgetConfiguration } from 'state/Widget';

import { EventsType, WindowMessageEvent } from './types';

let origin;

export const initializeWebChat = (e: MessageEvent, dispatch: AppDispatch) => {
  const url = new URL(e.origin);
  origin = e.origin;
  dispatch(
    setWidgetConfiguration({
      appKey: e.data.payload,
      hostReferer: `${url.hostname}`,
    })
  );
  dispatch(fetchAppConfig());
};

export const processMessageEvents = (e: MessageEvent, dispatch: AppDispatch) => {
  switch (e.data?.type) {
    case EventsType.CC_WEBCHAT_BOOT:
      initializeWebChat(e, dispatch);
      break;
  }
};

export const dispatchMessageEvent = (messageEvent: WindowMessageEvent) => {
  parent.postMessage(messageEvent, origin);
};

export const getBlobFromPreSignedUrl = async (url: string) => url;
